import { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';

export default function RequestButton({ songId, recentlyPlayed = false, compact = false, disabled = false }) {
  const { authToken } = useAuth();
  const [requesting, setRequesting] = useState(false);
  const [queued, setQueued] = useState(false);

  const handleRequest = async () => {
    if (!authToken) {
      toast.error('🔒 You must be logged in to request.');
      return;
    }

    try {
      setRequesting(true);
      const res = await fetch(`/api/song/${songId}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (res.status === 200) {
        toast.success('✅ Song successfully queued!');
        setQueued(true);
      } else if (res.status === 429) {
        toast.error('⏱️ You\'re queuing too fast. Wait a moment.');
      } else if (res.status === 403) {
        toast.error('⛔ You already have 2 songs in the queue.');
      } else if (res.status === 409) {
        toast.error('📻 This song was played recently.');
      } else {
        toast.error('❌ Unexpected server response.');
      }
    } catch (err) {
      toast.error('❌ Failed to queue song.');
      console.error(err);
    } finally {
      setRequesting(false);
    }
  };

  const isDisabled = requesting || recentlyPlayed || queued || disabled;

  return (
    <>
      <button
        onClick={handleRequest}
        disabled={isDisabled}
        className={`${
          compact ? 'px-2 py-1 text-xs' : 'px-3 py-1'
        } bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50`}
      >
        {queued
          ? 'Queued'
          : requesting
          ? '...'
          : recentlyPlayed || disabled
          ? 'Locked'
          : 'Request'}
      </button>
    </>
  );
}
